import type { User, Commit } from '../types/api';

const NAV_STATE_COOKIE = 'nav-state';
const NAV_STATE_TTL = 10; // 10 seconds - just for immediate navigation

interface NavState {
  user?: User;
  commit?: Commit;
  timestamp: number;
}

function getCookieDomain(): string {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname.includes('127.0.0.1')) {
    return ''; // No domain for localhost
  }
  return '.commit.you'; // Shared across all subdomains
}

export function setNavState(state: Partial<Omit<NavState, 'timestamp'>>) {
  const data = JSON.stringify({ ...state, timestamp: Date.now() });
  const domain = getCookieDomain();
  const domainAttr = domain ? `; domain=${domain}` : '';

  // Set cookie with short expiry, shared across subdomains
  document.cookie = `${NAV_STATE_COOKIE}=${encodeURIComponent(data)}; path=/${domainAttr}; max-age=${NAV_STATE_TTL}; SameSite=Lax`;
}

export function getNavState(): NavState | null {
  const match = document.cookie.match(new RegExp(`${NAV_STATE_COOKIE}=([^;]+)`));
  if (!match) return null;

  try {
    const state = JSON.parse(decodeURIComponent(match[1])) as NavState;

    // Clear the cookie after reading (one-time use)
    const domain = getCookieDomain();
    const domainAttr = domain ? `; domain=${domain}` : '';
    document.cookie = `${NAV_STATE_COOKIE}=; path=/${domainAttr}; max-age=0`;

    return state;
  } catch {
    return null;
  }
}
